import React from 'react'


import './Quote.css'
function Quote() {
  return (
    <div className='kote'>

      <div className='quote_container'>
        <div className='kote-content'>
          <img src='2.png' alt='dar lkbira' />
          <h1>الــــخير يبـــــــقى</h1>
          <h4>وأثرك الطيب يدوم</h4>
          <p className='p_laptop'>في قلب مدينة الصويرة، نعمل معًا لتحقيق حلم كبير، "الدار لكبيرة" – بيت دافئ يحتضن الأيتام، يوفر لهم الأمان، التعليم، والرعاية التي يستحقونها </p>

          <p className='p_mobile'></p>
          <span className='span_mobile'>في قلب مدينة الصويرة، نعمل معًا لتحقيق حلم كبير، الدار لكبيرة بيت دافئ يحتضن الأيتام، يوفر لهم الأمان، التعليم، والرعاية التي يستحقونها </span>


        </div>
        <div className='kote-photos'>
          <img src='b1.png' alt='dar lkbira' />
          <img src='b2.png' alt='dar lkbira' />
        </div>
      </div>

      <div className='kote-photos-mobile'>
          <img src='b1.png' alt='dar lkbira' />
          <img src='b2.png' alt='dar lkbira' />
      </div>


    </div>
  )
}

export default Quote